import { CompanySearchUIFilters } from '@/components/flows/PanelInviteFlow/utils/types'

export type PanelInviteStep =
  | 'companySearch'
  | 'createPanelRequest'
  | 'commercialAgreements'
  | 'inviteNewFirm'
  | 'invitationSummary'

export const PANEL_INVITE_STEPS: Record<PanelInviteStep, PanelInviteStep> = {
  companySearch: 'companySearch',
  createPanelRequest: 'createPanelRequest',
  commercialAgreements: 'commercialAgreements',
  inviteNewFirm: 'inviteNewFirm',
  invitationSummary: 'invitationSummary',
}

export const INITIAL_COMPANY_SEARCH_FILTERS: CompanySearchUIFilters = {
  isRqRated: 0,
  name: '',
  address: '',
  location: null,
  lat: null,
  lon: null,
  distance: 10,
  frns: [],
  areasOfAdvices: [],
  specialisms: [],
  accreditations: [],
  specialistQualifications: [],
  minInvestableAssets: null,
  isTransactionalWork: null,
  companyTypeId: 1,
  pageSize: 30,
  page: 1,
}
